// Relative, so it works on any domain: on the VPS Caddy forwards /api to the
// backend; locally the dev server does (see "proxy" in package.json).
const BASE_URL = "/api";

export const api = {
  category: async (lang) => {
    const res = await fetch(`${BASE_URL}/category?lang=${lang}`);
    if (!res.ok) throw new Error("Category request failed");
    return res.json();
  },
  poi: async (categoryId, lang) => {
    const res = await fetch(`${BASE_URL}/poi?categoryId=${categoryId}&lang=${lang}`);
    if (!res.ok) throw new Error("POI request failed");
    return res.json();
  },
  poo: async (lang) => {
    const res = await fetch(`${BASE_URL}/poo?lang=${lang}`);
    if (!res.ok) throw new Error("POO request failed");
    return res.json();
  },

  // style
  style: async () => {
    const res = await fetch(`${BASE_URL}/style`);
    if (!res.ok) throw new Error("Style request failed");
    return res.json();
  },

  // language
  language: async () => {
    const res = await fetch(`${BASE_URL}/language`);
    if (!res.ok) throw new Error("Language request failed");
    return res.json();
  },

  // topic
  topic: async (lang) => {
    const res = await fetch(`${BASE_URL}/topic?lang=${lang}`);
    if (!res.ok) throw new Error("Topic request failed");
    return res.json();
  },

  // groups (target audiences)
  groups: async (lang) => {
    const res = await fetch(`${BASE_URL}/groups?lang=${lang}`);
    if (!res.ok) throw new Error("Groups request failed");
    return res.json();
  },

  // route (Themenrouten)
  route: async (lang) => {
    const res = await fetch(`${BASE_URL}/route?lang=${lang}`);
    if (!res.ok) throw new Error("Route request failed");
    return res.json();
  },

  // listing (Gastronomie, Ferienhäuser, … — type matches listing_type.key)
  listing: async (type, lang) => {
    const res = await fetch(`${BASE_URL}/listing?type=${type}&lang=${lang}`);
    if (!res.ok) throw new Error("Listing request failed");
    return res.json();
  },

  // filter categories within a listing type (Restaurant, Café, …)
  listingCategories: async (type, lang) => {
    const res = await fetch(`${BASE_URL}/listing/categories?type=${type}&lang=${lang}`);
    if (!res.ok) throw new Error("Listing category request failed");
    return res.json();
  },

  // events (Veranstaltungskalender) — one entry per occurrence day, from/to as YYYY-MM-DD
  events: async (from, to, lang) => {
    const res = await fetch(`${BASE_URL}/event?from=${from}&to=${to}&lang=${lang}`);
    if (!res.ok) throw new Error("Event request failed");
    return res.json();
  },

  // QR code location (Standort an einem Schild) by its slug, e.g. "thiessow"
  qr: async (slug) => {
    const res = await fetch(`${BASE_URL}/qr/${encodeURIComponent(slug)}`);
    if (!res.ok) throw new Error("QR request failed");
    return res.json();
  }
};